import { GenericError } from '@cian/peperrors/shared';
export class ParseQueryError extends GenericError {
    constructor(message) {
        super({ type: 'ParseQueryError', domain: 'http-api', message });
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ParseQueryError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}
//# sourceMappingURL=ParseQueryError.js.map